import axios from "axios";
import consts from "../consts";
import { setErroAPI, setError, setSuccess } from "../common/toast/toast";
import { initialize } from "redux-form";
import confirmDialog from "../common/dialog/confirmDialog";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";
import FormatUtils from "../common/formatUtils/FormatUtils";

export function setModoTela(modo, registro = {}) {
    return {
        type: "CONTRATO_ALUGUEL_MODO_TELA",
        payload: {
            modo: modo,
            registro: registro,
        },
    };
}

export function setAguardando(aguardando) {
    return {
        type: "CONTRATO_ALUGUEL_SET_AGUARDANDO",
        payload: aguardando,
    };
}

export function initForm(registro = {}) {
    if (!registro.contratos) {
        registro.contratos = [];
    }

    if (!registro.ids_unidades_remotas) {
        registro.ids_unidades_remotas = [];
    }

    if (registro.geradora_externa) {
        registro.id_unidade_geradora = 0;
    }
    return [initialize("contratoAluguelForm", registro)];
}

export function setFiltro(filtro) {
    return {
        type: "CONTRATO_ALUGUEL_FILTRO",
        payload: filtro,
    };
}

export function getLista() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : getState().contratoAluguel.filtro.id_cliente;

            const idUc = getState().contratoAluguel.filtro.id_unidade_consumidora;

            dispatch(setAguardando(true));
            const resp = await axios.get(
                `${consts.API_URL}/contrato-aluguel?id_cliente=${idCliente}&id_unidade_consumidora=${idUc}&id_empresa=${idEmpresa}`
            );
            dispatch({
                type: "CONTRATO_ALUGUEL_LISTADO",
                payload: resp,
            });
        } catch (e) {
            setErroAPI(e);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function getListaGrupoContratoAluguel({ idCliente }) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            dispatch(setAguardando(true));
            const resp = await axios.get(`${consts.API_URL}/grupo-contrato-aluguel?id_cliente=${idCliente}&id_empresa=${idEmpresa}`);
            dispatch({
                type: "GRUPO_CONTRATO_ALUGUEL_LISTADO",
                payload: resp,
            });
        } catch (e) {
            setErroAPI(e);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
        const registroFormatado = { ...registro };
        registroFormatado.ids_unidades_remotas = registro.ids_unidades_remotas.map((uc) => parseInt(uc.value));

        if (registroFormatado.id_unidade_geradora == 0) {
            registroFormatado.id_unidade_geradora = null;
            registroFormatado.geradora_externa = true;
        } else {
            registroFormatado.geradora_externa = false;
        }

        if (!registroFormatado.id) {
            dispatch(setAguardando(true));

            axios
                .post(`${consts.API_URL}/contrato-aluguel`, {
                    ...registroFormatado,
                    id_usuario_inclusao: getState().auth.usuario.id,
                })
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    dispatch(
                        initForm({
                            ...registro,
                            id: resp.data.id,
                        })
                    );
                    dispatch(setAguardando(false));
                })
                .catch((e) => {
                    setErroAPI(e);
                    dispatch(setAguardando(false));
                });
        } else {
            confirmDialog("Deseja realmente alterar?", () => {
                dispatch(setAguardando(true));

                axios
                    .put(`${consts.API_URL}/contrato-aluguel`, {
                        ...registroFormatado,
                        id_usuario_alteracao: getState().auth.usuario.id,
                    })
                    .then((resp) => {
                        setSuccess("Operação Realizada com sucesso.");
                        dispatch(getLista());
                        dispatch(setModoTela("lista"));
                        dispatch(setAguardando(false));
                    })
                    .catch((e) => {
                        setErroAPI(e);
                        dispatch(setAguardando(false));
                    });
            });
        }
    };
}

export function salvarGrupoContratoAluguel(registro, callback) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const registroFormatado = { ...registro };
            const endpoint = `${consts.API_URL}/grupo-contrato-aluguel`;
            if (!registroFormatado.id) {
                dispatch(setAguardando(true));
                await axios.post(endpoint, { ...registroFormatado, id_usuario_inclusao: usuarioLogado.id });
                setSuccess("Operação Realizada com sucesso.");
                dispatch(getListaGrupoContratoAluguel({ idCliente: registro.id_cliente }));
            } else {
                if (!window.confirm("Deseja realmente alterar?")) return;
                dispatch(setAguardando(true));
                await axios.put(endpoint, { ...registroFormatado, id_usuario_alteracao: usuarioLogado.id });
                setSuccess("Operação Realizada com sucesso.");
                dispatch(getListaGrupoContratoAluguel({ idCliente: registro.id_cliente }));
            }
            if (callback) callback();
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function salvarContrato({ formularioValues, registro, callback }) {
    return async (dispatch, getState) => {
        const registroFormatado = { ...registro };
        registroFormatado.valor_mensal_aluguel = parseFloat(FormatUtils.formatarValorBanco(registro.valor_mensal_aluguel, 2));
        registroFormatado.quantidade_energia_contratada_anual = parseFloat(FormatUtils.formatarValorBanco(registro.quantidade_energia_contratada_anual, 2));
        registroFormatado.valor_custo_gestao_contrato_aluguel = parseFloat(FormatUtils.formatarValorBanco(registro.valor_custo_gestao_contrato_aluguel, 2));
        registroFormatado.percentual_custo_gestao_contrato_aluguel = parseFloat(FormatUtils.formatarValorBanco(registro.percentual_custo_gestao_contrato_aluguel, 2));

        try {
            dispatch(setAguardando(true));
            if (!registroFormatado.id) {
                await axios.post(`${consts.API_URL}/contrato-aluguel-historico`, {
                    ...registroFormatado,
                    id_usuario_inclusao: getState().auth.usuario.id,
                });
            } else if (window.confirm("Deseja realmente alterar?")) {
                await axios.put(`${consts.API_URL}/contrato-aluguel-historico`, {
                    ...registroFormatado,
                    id_usuario_alteracao: getState().auth.usuario.id,
                });
            }

            //buscar lista de contratos e atualizar form
            const contratos = await getListaContratos(registroFormatado.id_contrato_aluguel);
            dispatch(initForm({ ...formularioValues, contratos }));
            setSuccess("Operação Realizada com sucesso.");
            if (callback) callback();
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

async function getListaContratos(id_contrato_aluguel) {
    try {
        const resp = await axios.get(`${consts.API_URL}/contrato-aluguel-historico?id_contrato_aluguel=${id_contrato_aluguel}`);
        return resp.data || [];
    } catch (erro) {
        setErroAPI(erro);
        return [];
    }
}

export function excluir(registro) {
    return (dispatch, getState) => {
        const usuarioLogado = getState().auth.usuarioLogado;
        if (!usuarioLogado) return {};

        confirmDialog("Deseja realmente excluir?", () => {
            axios
                .delete(`${consts.API_URL}/contrato-aluguel?id=${registro.id}&id_usuario_alteracao=${usuarioLogado.id}`)
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    dispatch(getLista());
                    dispatch(setModoTela("lista"));
                })
                .catch((e) => {
                    setErroAPI(e);
                });
        });
    };
}
export function excluirGrupoContratoAluguel(registro, callback) {
    return (dispatch, getState) => {
        const usuarioLogado = getState().auth.usuarioLogado;
        if (!usuarioLogado) return {};

        confirmDialog("Deseja realmente excluir?", () => {
            axios
                .delete(`${consts.API_URL}/grupo-contrato-aluguel?id=${registro.id}&id_usuario_alteracao=${usuarioLogado.id}`)
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    dispatch(getListaGrupoContratoAluguel({ idCliente: registro.id_cliente }));
                    if (callback) callback();
                })
                .catch((e) => {
                    setErroAPI(e);
                });
        });
    };
}

export function buscarArquivoContrato({ id, nome }) {
    return async (dispatch, getState) => {
        try {
            dispatch(setAguardando(true));
            const resp = await axios.get(`${consts.API_URL}/contrato-aluguel-historico/buscarArquivoContrato?id=${id}`);
            if (resp.data && resp.data.arquivo_contrato) {
                dispatch(setArquivoPDF(resp.data.arquivo_contrato, nome));
            }
        } catch (e) {
            setErroAPI(e);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluirContrato({ formularioValues, id_contrato_aluguel, id }) {
    return (dispatch, getState) => {
        confirmDialog("Deseja realmente excluir?", () => {
            axios
                .delete(`${consts.API_URL}/contrato-aluguel-historico?id=${id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
                .then(async (resp) => {
                    //buscar lista de contratos e atualizar form
                    //buscar lista de contratos e atualizar form
                    const contratos = await getListaContratos(id_contrato_aluguel);
                    dispatch(
                        initForm({
                            ...formularioValues,
                            contratos,
                        })
                    );
                    setSuccess("Operação Realizada com sucesso.");
                })
                .catch((e) => {
                    setErroAPI(e);
                });
        });
    };
}

export function getListaCliente() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = axios.get(`${consts.API_URL}/cliente/listarSelect?id_empresa=${idEmpresa}`);
            dispatch({
                type: "CONTRATO_ALUGUEL_CLIENTE_SELECT_LISTADO",
                payload: request,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function getListaUnidadeConsumidora() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = axios.get(`${consts.API_URL}/unidadeConsumidora/listarSelect?id_empresa=${idEmpresa}`);
            dispatch({
                type: "CONTRATO_ALUGUEL_UNIDADE_CONSUMIDORA_SELECT_LISTADO",
                payload: request,
            });
        } catch (e) {
            setErroAPI(e);
        }
    };
}

export function getListaTipoCustoGestaoContratoAluguel() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const request = await axios.get(`${consts.API_URL}/contrato-aluguel-historico/tipo-custo-gestao/listar-select`);
            dispatch({
                type: "CONTRATO_ALUGUEL_TIPO_CUSTO_GESTAO_SELECT_LISTADO",
                payload: request,
            });
        } catch (e) {
            setErroAPI(e);
        }
    };
}

export function buscarPdfContrato({ id, nome }) {
    return async (dispatch, getState) => {
        try {
            const resp = await axios.get(`${consts.API_URL}/contrato-aluguel/buscarPdfContrato?id=${id}`);
            if (resp.data && resp.data.arquivo1) {
                let base64 = resp.data.arquivo1;
                const indiceInicioExtensao = base64.indexOf("/") + 1;
                const indiceFimExtensao = base64.indexOf(";");
                const extensao = base64.substring(indiceInicioExtensao, indiceFimExtensao);

                dispatch(setArquivoPDF(resp.data.arquivo1, `${nome}.${extensao}`, "landscape"));
            }
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}
